import React, { useContext, useEffect, useState } from "react";
//
import { FormattedMessage, useIntl } from "react-intl";
// ui
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { styled } from "@material-ui/styles";
//
import Typography from "@mui/material/Typography";
import ButtonPopup from "../../../../../../../common/components/popup/ButtonPopup";
import ChipMain from "../../../../../../../common/components/chip/ChipMain";
import CommonListItem from "../../../../sidebar/common/CommonListItem";
// store
import { StoreContext } from "../../../../../../../store/StoreProvider";
import Act from "../../../../../../../store/actions";
//
// hooks
import useModulePublic from "../../../../../../hooks/useModulePublic";
// config,utils
// style
import { MODULE_ID } from "../../../../../../../config/CONSTANTS";
import datasetIcon from "../../../../../../../../images/icon_folder/icon_folder_dark/資料集.svg";
import ListItemBasic from "../../../../../../../common/components/listitem/ListItemBasic";

const popupMenuPosition = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "right",
  },
};

const StyledList = styled(List)(({ theme }) => ({
  "&.MuiList-root": {
    padding: 0,
    // padding: "16px 24px",
    // width: "248px",
  },
}));

const DatasetTool = () => {
  // props

  // route,intl
  const intl = useIntl();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { dataset } = sna;
  // local state
  const [datasetSelect, setDatasetSelect] = useState([]);
  const [listItemFocus, setListItemFocus] = useState(null);
  const [popupPageIdx, setPopupPageIdx] = useState(0);
  const [popPageCtx, setPopPageCtx] = useState({});
  // hooks
  const { handlePublic } = useModulePublic();

  const handleDisabled = (moduleId) => !handlePublic(moduleId);

  useEffect(() => {
    // 整理dataset中的 public, group, private中有 checked 的資料到 datasetSelect 中
    const newDatasetSelect = Object.entries(dataset).reduce(
      (acc, [key, list]) => {
        // 忽略 select 類別
        if (key === "select") return acc;
        (list || []).forEach((file) => {
          if (file.checked) {
            acc.push({
              ...file,
              datasetType: key, // group, public, personal
            });
          }
        });
        return acc;
      },
      []
    );
    setDatasetSelect(newDatasetSelect);
  }, [dataset]);

  const handleListItemClick = (_dataset) => (e) => {
    // console.log("handleListItemClick _dataset", _dataset);
  };

  const getChipLabel = (datasetType) => {
    if (datasetType === "personal") {
      return intl.formatMessage({
        id: "sna.toppanel.datasettool.datasettype.personal",
        defaultMessage: "個人",
      });
    }
    if (datasetType === "group") {
      return intl.formatMessage({
        id: "sna.toppanel.datasettool.datasettype.group",
        defaultMessage: "團隊",
      });
    }
    if (datasetType === "public") {
      return intl.formatMessage({
        id: "sna.toppanel.datasettool.datasettype.public",
        defaultMessage: "公共",
      });
    }
    return "";
  };

  const getPopupPageListItem = () => ({
    children: (
      <Box px={3} py={2}>
        <Box mb={4}>
          <Typography variant="body2">
            <FormattedMessage id="sna.topPanel.dataset" />
          </Typography>
        </Box>
        <StyledList>
          {datasetSelect.map((ds, idx) => (
            <ListItemBasic
              key={idx.toString()}
              textPrimary={
                <Typography variant="body2">{ds.displayName}</Typography>
              }
              listItemProps={{
                secondaryAction: (
                  <Box ml={4}>
                    <ChipMain
                      variant="contained"
                      label={
                        <Typography variant="caption">
                          {getChipLabel(ds.datasetType)}
                        </Typography>
                      }
                    />
                  </Box>
                ),
              }}
              listItemButtonProps={{
                sx: {
                  "&.MuiListItemButton-root": {
                    paddingLeft: 0,
                    paddingRight: 0,
                  },
                },
              }}
              listItemTextProps={{}}
            />
          ))}
        </StyledList>
      </Box>
    ),
    useMenuItem: false,
  });

  const popupPage0 = {
    body: [getPopupPageListItem()].filter((item) => !!item),
  };

  // popup 所有分頁
  const popupPages = [popupPage0];

  // 當選擇的 dataset 變更 or pageIdx 便更時, 重新產生 popup 內容
  useEffect(() => {
    setPopPageCtx(popupPages[popupPageIdx]);
  }, [popupPageIdx, datasetSelect]);

  const getMenuProps = () => ({
    ...popPageCtx,
    ...popupMenuPosition,
    onClose: () => setPopupPageIdx(0),
    sx: {
      "& .MuiPopover-paper": {
        minWidth: "248px",
      },
    },
  });

  return (
    <Box>
      <ButtonPopup
        buttonProps={{
          variant: "neutral",
          text: intl.formatMessage({
            id: "sna.topPanel.dataset",
            defaultMessage: "當前資料集",
          }),
          disabled: handleDisabled(MODULE_ID.snaTopPanelDataset),
          startIcon: <img src={datasetIcon} alt="datasetIcon" />,
        }}
        badgeProps={{
          badgeContent: datasetSelect.length,
        }}
        menuProps={{
          ...getMenuProps(),
        }}
      />
    </Box>
  );
};

DatasetTool.propTypes = {};

DatasetTool.defaultProps = {};

export default DatasetTool;
